import { action, atom } from '@reatom/framework'

import { Async } from '@blade/std-lib'

import type { ConfirmResultOk, ConfirmResultError } from './confirm-result'
import type { OmitKey } from '@blade/std-lib'
import type { Ctx } from '@reatom/framework'
import type { ConfirmDialogProps } from '@root/shared/ui-kit'

type Props = OmitKey<ConfirmDialogProps, 'open' | 'onOpenChange'>
export const confirmDialogControllerAtom = atom<ConfirmDialogProps | undefined>(
  undefined,
  'confirmDialogControllerAtom',
)

export const confirmAction = action(async (ctx: Ctx, props: Props) => {
  const deferred = Async.deferred<ConfirmResultError, ConfirmResultOk>()

  confirmDialogControllerAtom(ctx, {
    ...props,
    onCancel: () => deferred.fail('Cancel'),
    onOpenChange: () => deferred.fail('Close'),
    onConfirm: () => deferred.succeed('Ok'),
  })

  const result = await ctx.schedule(() => deferred.promise)

  confirmDialogControllerAtom(ctx, undefined)

  return result
}, 'confirmAction')
